<!--
File Name          : navbar-layout.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="component-container">
    <div class="toolbar" role="toolbar" aria-label="Main toolbar">
        <div class="device-info">
            @if(devices.length>0 && devices[0].hasDevice) {
                <app-sensor-color   [deviceColor]="devices[0].deviceColor ?? '#ffffff'" [onClickHandler]="notifyDevice(devices[0])" [tooltipText]="devices[0].deviceState !== Device_State.READY_FOR_PACKETS ? 'Device Out of Range':'Flash my sensor'" [showNotification]="devices[0].deviceState !== Device_State.READY_FOR_PACKETS"></app-sensor-color>
                <app-sensor-battery   [batteryLevel]="devices[0].batteryState" />
                <dx-button class="device-settings-button"  icon="preferences" stylingMode="text" (onClick)="showDeviceSettings(devices[0])"></dx-button>
                <dx-button  class="remove-button" icon="remove" stylingMode="text" (onClick)="removeDevice(devices[0])"></dx-button>
            }
        </div>
        <ng-container *ngIf="!screenService.isMobile; else mobilefiller">
            <img style="margin-left: auto;" class="path-icon" width="36" height="36" src="/assets/Sensor_Icon.svg" alt="Sensor">
            <img *ngIf="unit" [src]="unit.iconPath" [alt]="unit.title + ' unit icon'" class="path-icon" width="36" height="36" />
            <div style="margin-right: auto;">{{level?.id == 'advanced' ? 'Adv':''}} {{lesson?.title ? 'L' + lesson?.title : ''}}</div>
        </ng-container>
        <ng-template #mobilefiller>
            <div style="width:100%"></div>
        </ng-template>
        
        <div  class="toolbar-spacer">
            <dx-button class="help-button" icon="help" stylingMode="text" (onClick)="showHelpWindow()" hint="Help"></dx-button>
            <dx-button class="home-button" icon="home" stylingMode="text" (onClick)="checkGoHome()" hint="Go home"></dx-button>
        </div>
    </div>
    <div class="remaining-container">
        <router-outlet></router-outlet>
    </div>
    <div class="footer">
        <div class="outside-container">
            <dx-button width="100%" style="margin:0;"stylingMode="outlined" text="About" (onClick)="showAboutPopup=true;"></dx-button>
            
        </div>


        <div style="width:100%; display: flex;">
            @if(screenService.isMobile) {
                <img style="margin-left: auto;" class="path-icon" width="36" height="36" src="/assets/Sensor_Icon.svg" alt="Sensor">
                <img *ngIf="unit" [src]="unit.iconPath" [alt]="unit.title + ' unit icon'" class="path-icon" width="36" height="36" />
                <div style="margin-right: auto;">{{level?.id == 'advanced' ? 'Adv':''}} {{lesson?.title ? 'L' + lesson?.title : ''}}</div>
            
            }
        </div>
        
        <div class="outside-container">
            <img style="height: calc(100% - 16px); margin:0;" src="/assets/branding/secondary_logo_white.svg" alt="Datasnap" width="120" height="40">
        </div>
        

        <!-- <ng-container *ngIf="!screenService.isMobile; else mobileFooter">
            <div style="width:180px;"></div>
            <img style="height: calc(100% - 16px); width: 180px;" src="/assets/branding/secondary_logo_white.svg">
        
        </ng-container>
        <ng-template #mobileFooter>
            <app-sensor-color  *ngIf="devices[0]?.device" [deviceColor]="devices[0].deviceColor ?? '#ffffff'" [onClickHandler]="notifyDevice(devices[0])" [tooltipText]="devices[0]?.device?.deviceState !== Device_State.READY_FOR_PACKETS ? 'Device Out of Range':'Flash my sensor'" [showNotification]="devices[0]?.device?.deviceState !== Device_State.READY_FOR_PACKETS"></app-sensor-color>
            <app-sensor-battery  *ngIf="devices[0]?.device" [batteryLevel]="devices[0].device?.battery_state ?? 0" />
            <dx-button class="device-settings-button" *ngIf="devices[0]?.device" icon="preferences" stylingMode="text" (onClick)="showDeviceSettings(devices[0])"></dx-button>
            <dx-button *ngIf="devices[0]?.device" class="remove-button" icon="remove" stylingMode="text" (onClick)="removeDevice(devices[0])"></dx-button>
            <dx-button class="help-button" icon="help" stylingMode="text" (onClick)="showHelpWindow()"></dx-button>
            <dx-button class="home-button" icon="home" stylingMode="text" (onClick)="checkGoHome()"></dx-button>
        </ng-template> -->

        
    </div>
</div>

<dx-popup
    [(visible)]="showHelpPopup"
    title="Sensor Light Guide"
    width="480"
    height="680"
    maxWidth="100%"
    maxHeight="100%"
    [showCloseButton]="true"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
>
    <app-blink-pattern-help></app-blink-pattern-help>
</dx-popup>

<dx-popup
    [(visible)]="showDeviceSettingsPopup"
    title="Device Settings"
    maxWidth="480"
    maxHeight="400"
    [showCloseButton]="true"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    
>
    <app-device-settings [device]="devices[0]"></app-device-settings>
</dx-popup>

<dx-popup
    [(visible)]="showAboutPopup"
    title="About"
    width="400"
    height="360"
    maxWidth="100%"
    maxHeight="100%"
    [showCloseButton]="true"
    [hideOnOutsideClick]="true"
    [dragEnabled]="false"
>
    <div class="about-container">
        <div class="about-info">Version: {{ appVersion }}</div>
        <div class="about-info">©{{ getCurrentYear() }} Realityworks.</div>
        <div class="about-info">All rights reserved.</div>
        <dx-button width="100%" type="default" text="Privacy Policy" (onClick)="openPrivacyPolicy()"></dx-button>
        <dx-button width="100%" type="default" text="Support Website" (onClick)="openProductSupport()"></dx-button>
    </div>
    
</dx-popup>